// app/javascript/channels/chat_channel.js
import consumer from "./consumer"


consumer.subscriptions.create({channel: "NotificationsChannel"}, {
    connected() {
        console.log("NotificationsChannel:: connected");
        //  console.log(this);
    },
    received(data) {
        console.log("channel::notifications, received", JSON.stringify(data));
        // Create a new event, allow bubbling, and provide any data you want to pass to the "detail" property
        const eventAwesome = new CustomEvent("notification:show", {
            bubbles: true,
            detail: {text: () => data},
        });
        console.log("channel::public", JSON.stringify(data));
    }

})


// app/javascript/channels/appearance_channel.js